import { TargetSegment, SelectionType } from '@amzn/fire-tv-campaign-automation-service';
import { WeblabConstants } from 'src/constants';
import CloseIcon from '@mui/icons-material/Close';

import styles from './WeblabSelectedItemsList.module.css';

interface WeblabSelectedItemsListProps {
  weblabs: TargetSegment[];
  onRemoveItem: (index: number) => void;
  headerText?: string;
}

const WeblabSelectedItemsList: React.FC<WeblabSelectedItemsListProps> = ({
  weblabs,
  onRemoveItem,
  headerText = WeblabConstants.DEFAULT_HEADER_TEXT,
}) => {
  if (weblabs.length === 0) return null;

  const itemCount = weblabs.length;
  const ariaLabel = `${itemCount} weblab${itemCount === 1 ? '' : 's'} selected`;

  return (
    <div className={`${styles.weblabRoot} ${styles.selectedContainer}`}>
      <div className={styles.selectedHeader}>{headerText}</div>
      <div className={styles.selectedList} role="list" aria-label={ariaLabel}>
        {weblabs.map((weblab, index) => {
          const selectionTypeClass =
            weblab.selectionType === SelectionType.INCLUDE ? styles.include : styles.exclude;

          return (
            <div
              key={weblab.segmentId}
              className={`${styles.selectedItem} ${selectionTypeClass}`}
              role="listitem"
            >
              <span className={styles.itemLabel}>{weblab.segmentId}</span>
              <span className={styles.treatment}>{weblab.treatment}</span>
              <button
                className={styles.removeButton}
                data-testid={`remove-${weblab.segmentId}`}
                onClick={() => onRemoveItem(index)}
                aria-label={`Remove ${weblab.segmentId}`}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WeblabSelectedItemsList;
